import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProfileNavigate from 'components/ProfileNavigate';
import withRouter, { RouteComponentProps } from 'utils/withRouter';

// 需重定向的链接
const links = {
    safe: [
        { old: '/safe/changepassword/*', new: '/profile/security/modify/password' }, // 修改密码
        { old: '/safe/changeemail/*', new: '/profile/security/modify/email' }, // 修改邮箱
        { old: '/safe/changephone/*', new: '/profile/security/modify/phone' }, // 修改手机号
        { old: '/safe/credentials/*', new: '/profile/security/link' }, // IB用户名、密码
        { old: '/safe/verifyemail/*', new: '/profile/security/active/email' }, // 激活邮箱
        { old: '/safe/*', new: '/profile/security' }
    ],
    retrive: [{ old: '/retrive/*', new: '/account/password/verify' }],
    personal: [
        { old: '/personal/position/*', new: '/profile/transfer' }, // 转股
        { old: '/personal/transfer/deposit/plaid-continue', new: '/profile/deposit/ach/plaid-continue' }, // 入金plaid回调地址
        { old: '/personal/transfer/withdraw/plaid-continue', new: '/profile/withdraw/ach/plaid-continue' }, // 出金plaid回调地址
        { old: '/personal/transfer/deposit/*', new: '/profile/deposit' }, // 入金
        { old: '/personal/transfer/withdraw/*', new: '/profile/withdraw' }, // 出金
        { old: '/personal/transfer/history/*', new: '/profile/funding-records' }, // 出入金记录
        { old: '/personal/account/step/check', new: '/profile/security/2fa/install' }, // 两步验证开启
        { old: '/personal/account/step/info', new: '/profile/security/2fa/uninstall' }, // 两步验证关闭
        { old: '/personal/account/trust/*', new: '/profile/security/trust' }, // trust管理
        { old: '/personal/close/setclose', new: '/profile/logoff/close' }, // 关户
        { old: '/personal/close/setdel', new: '/profile/logoff/delete' }, // 删户
        { old: '/personal/viewdoc/*', new: '/profile/report' }, // 报表
        { old: '/peronsal/*', new: '/profile' }
    ]
};

const RedirectNew: React.FC<RouteComponentProps & { linkType: keyof typeof links }> = ({ location, linkType }) => {
    const curLinks = links[linkType];

    return (
        <Routes>
            {curLinks.map(it => {
                return (
                    <Route
                        key={it.old}
                        path={it.old.replace(/^\/\w+\//, '')}
                        element={<ProfileNavigate to={{ ...location, pathname: it.new }} replace />}
                    />
                );
            })}
        </Routes>
    );
};

export default withRouter(RedirectNew);
